<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <Header/>
    <Scroll/>
    <div class="hp_orderCompWrap">
      <div class="hp_orderCompInner">
        <h2 class="hp_orderCompTit">
          주문이 완료되었습니다.
        </h2>
        <div class="hp_orderCompContent">
          <p>주문일자 : {{statusData.orderData.order_registe}}</p>
        </div>
        <div class="hp_orderCompBtnBox">
          <button class="hp_orderCompBtnB" @click="goToMyPage">주문 내역 보기</button>
          <button class="hp_orderCompBtnW" @click="goToMain">메인으로</button>
        </div>
      </div>
    </div>
    <Footer/>
  </div>

</template>

<!-- eslint-disable camelcase -->
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_order_one
} from '../../ETC/Axios.vue'

export default {
  name: 'ReservationSuccess',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    return {
      statusData: ref({
        orderData: []
      })
    }
  },
  methods: {
    goToMyPage () {
      const { order_receive_name, order_phone_number } = this.statusData.orderData
      const myID = 1

      this.$router.push({
        path: '/My',
        query: {
          myID,
          orderReceiveName: order_receive_name,
          orderPhoneNumber: order_phone_number
        }
      })
    },
    goToMain () {
      this.$router.push({
        path: '/'
      })
    }
  },
  mounted () {
    get_order_one(this.$route.query.order_ID).then(result => {
      this.statusData.orderData = result[0]
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Order/OrderSuccess.vue